const debug = process.env.NODE_ENV === 'development'
const devURL = 'http://localhost:8100/'
const serverURL = process.env.VUE_APP_BASE_URL
const devAuthURL = 'http://localhost:8200/dj-rest-auth/'
const authURL = process.env.VUE_APP_AUTH_URL + 'dj-rest-auth/'
const devClasseURL = 'http://localhost:8001/'
const classeUrl = process.env.VUE_APP_LEGACY_CLASSE_HOST
const dataEngineUrl = process.env.VUE_APP_DATA_ENGINE_URL
const companionServer = process.env.VUE_APP_COMPANION_URL

const config = {
  debug,
  classeUrl: debug ? devClasseURL : classeUrl,
  dataEngineUrl,
  classeApiUrl: debug ? devClasseURL + 'api/' : classeUrl + 'api/',
  baseURL: debug ? devURL : serverURL,
  authURL: debug ? devAuthURL : authURL,
  authToken: localStorage.getItem('jwt') || null,
  libraryUrl: window.location.origin + process.env.VUE_APP_PUBLIC_PATH,
  pipelineUrl: 'https://pipeline.classe.workers.dev/',
  timeout: debug ? 0 : 30000,

  setToken (token) {
    this.authToken = token
  },
  companionUrl: companionServer
}

export default config
